import { useMutation } from "@tanstack/react-query";

import type { PostTopicFeedbackBody, Topic } from "@app/analytics/types";
import apiClient from "@app/common/api/apiClient";

import * as Events from "../events";

interface TopicReportFeedback {
  topicId: Topic["id"];
  feedback: PostTopicFeedbackBody;
}

const useTopicReportFeedback = () => {
  const submitFeedbackMutation = useMutation({
    mutationFn: async ({ topicId, feedback }: TopicReportFeedback) => {
      Events.submitTopicReportFeedback({
        feedback: feedback.feedback,
        reasons: feedback.reasons,
      });
      return apiClient.topics.postTopicFeedback(topicId, feedback);
    },
  });

  return {
    submitFeedback: submitFeedbackMutation,
  };
};

export default useTopicReportFeedback;
